import React, { useEffect, useState } from 'react'
import SelectUC from '../../../components/Form/SelectUC'
import { Col, Row } from 'antd'
import InputUC from '../../../components/Form/InputUC'
import DatePickerUC from '../../../components/Form/DatePickerUC'
import InputMaskUC from '../../../components/Form/InputMaskUC'
import useDropdown from '../context/useDropdown'
import { calculateAge } from '../../../utils/formatDate'
import { filterIsDeleted } from '../constant'

const Personal = ({ props }) => {
    const { form, isReadOnly } = props
    const { ddlTitle, ddlMaritalStatus, ddlRace, ddlReligion, ddlMilitaryStatus, ddlNationality
        , ddlAppProfileType
    } = useDropdown()
    const [isMilitary, setMilitary] = useState(false)
    // fix
    const ddlGender = [
        {
            value: 'ชาย',
            label: 'ชาย'
        },
        {
            value: 'หญิง',
            label: 'หญิง'
        }
    ]

    useEffect(() => {
        if (ddlTitle) {
            const title = ddlTitle?.filter(filterIsDeleted).length > 0 ? ddlTitle.filter(filterIsDeleted).find(e => e.value === form.getFieldValue('title')) : null
            form.setFieldsValue({
                title: !title ? null : title.value
            })
        }
        form.setFieldsValue({
            appProfileTypeInput: 'บุคคลภายนอก'
        })
    }, [ddlTitle])

    const handleBirthDateChange = (e) => {
        const age = calculateAge(e)
        if (e) {
            if (age < 18) {
                form.setFields([
                    {
                        name: ["age"],
                        errors: ["ไม่สามารถเลือกอายุต่ำกว่า 18 ปีได้"],
                    },
                ]);
            } else {
                form.setFields([{ name: ["age"], errors: [] }]);
            }
            form.setFieldValue('age', age)
        } else {
            form.setFieldValue('age', null)
            form.setFields([{ name: ["age"], errors: [], }]);
        }

    }

    const handleGender = (e) => {
        let _military = null
        if (e === 'หญิง') {
            const military = ddlMilitaryStatus.find(el => el.label === 'N/A')
            _military = military?.value ? military.value : ''
            setMilitary(true)
            form.setFields([{ name: ["militaryStatus"], errors: [], }]);
        } else {
            setMilitary(false)
        }
        form.setFieldValue('militaryStatus', _military)
    }

    const setDisabledDate = (current) => {
        const _date = convertToDate(current)
        const dateNow = convertToDate(new Date())
        return (_date > dateNow)

    };

    const convertToDate = (val) => {
        let _date = val ? new Date(val) : new Date();
        _date.setHours(0, 0, 0, 0);
        return _date;
    };

    const handleChange = (e) => {
        const val = e.target.value
        if (val.length < 16) {
            form.setFields([{ name: ['idCard'], errors: ['เลขบัตรประชาชนไม่ถูกต้อง'] }]);
        } else {
            form.setFields([{ name: ['idCard'], errors: [] }]);
        }
    }

    const handleChangeSalary = (e, columnName) => {
        let inputValue = e.target.value;
        const reg = /^-?\d*(\.\d*)?$/;
        if (!(reg.test(inputValue) || inputValue === '' || inputValue === '-')) {
            inputValue = inputValue.length > 0 ? (inputValue.substring(0, inputValue.length - 1)) : ''
        }

        form.setFieldsValue({ [columnName]: inputValue });
    }

    const handleFocus = (e, columnName) => {
        if (e?.target?.value) {
            const value = e?.target?.value.replace(/,/g, '')
            form.setFieldsValue({ [columnName]: value });
        }
        console.log('handleFocus', e.target.value)
    }

    const addCommas = (number) => {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const comma = () => {
        let num = form.getFieldsValue().salary
        if (num) {
            num = addCommas(parseInt(num))
            form.setFieldsValue({ salary: num });
            form.setFields([{
                name: ['salary'],
                errors: null
            }]);
        }
    }

    return (
        <div className="personal content-block p-3">
            <div className="block-title">ข้อมูลส่วนตัว</div>
            <Row className="py-2">
                {/* <Col xs={24} md={8} className='px-2'> */}
                <Col span={0} className='hidden'>
                    <SelectUC required={true} label='สถานะของผู้สมัคร' name={'appProfileType'} optionValues={ddlAppProfileType} />
                    {/* <InputUC required={true} label='สถานะของผู้สมัคร' disabled={true} name={'appProfileTypeInput'} /> */}
                </Col>
            </Row>
            {/* <div className='pl-3 color-error'>บุคลากรสภากาชาดไทย กรุณาใช้งานผ่าน V TRC Website หรือ Mobile Application</div> */}
            <Row className="py-2">
                <Col xs={24} md={8} className='px-2'>
                    <SelectUC disabled={isReadOnly} required={true} label='คำนำหน้า' name={'title'} optionValues={ddlTitle} />
                </Col>
                <Col xs={24} md={8} className='px-2'>
                    <InputUC disabled={isReadOnly} required={true} label='ชื่อ' maxLength={100} name={'firstName'} />
                </Col>
                <Col xs={24} md={8} className='px-2'>
                    <InputUC disabled={isReadOnly} required={true} label='นามสกุล' maxLength={100} name={'lastName'} />
                </Col>

            </Row>
            <Row className="py-2">
                <Col xs={24} md={8} className='px-2'>
                    <SelectUC disabled={isReadOnly} required={true} label='เพศ' name={'gender'} onChange={handleGender} optionValues={ddlGender} />
                </Col>
                <Col xs={24} md={8} className='px-2'>
                    <SelectUC disabled={isReadOnly} required={true} label='สัญชาติ' name={'nationality'} optionValues={ddlNationality} />
                </Col>
                <Col xs={24} md={8} className='px-2'>
                    <SelectUC disabled={isReadOnly} required={true} label='เชื้อชาติ' name={'race'} optionValues={ddlRace} />
                </Col>

            </Row>
            <Row className="py-2">
                <Col xs={24} md={8} className='px-2'>
                    <SelectUC disabled={isReadOnly} required={true} label='ศาสนา' name={'religion'} optionValues={ddlReligion} />
                </Col>
                <Col xs={24} md={8} className='px-2'>
                    <DatePickerUC disabled={isReadOnly} required={true}
                        label='วัน/เดือน/ปีเกิด'
                        name={'birthDate'}
                        disabledDate={(curr) => setDisabledDate(curr)}
                        onChange={handleBirthDateChange} />
                </Col>
                <Col xs={24} md={8} className='px-2'>
                    <InputUC label='อายุ' name={'age'} disabled={true} />
                </Col>
            </Row>
            <Row className="py-2">
                <Col xs={24} md={16} className='px-2'>
                    <InputMaskUC disabled={isReadOnly} required={true} label='เลขบัตรประชาชน' onBlur={handleChange} name={'idCard'} mask='9-9999-99999-999' placeholder={'1-XXXX-XXXXX-XX-X'} />
                </Col>
            </Row>
            <Row className="py-2">
                <Col xs={24} md={8} className='px-2'>
                    <SelectUC disabled={isReadOnly} required={true} label='สถานภาพการสมรส' name={'maritalStatus'} optionValues={ddlMaritalStatus} />
                </Col>
                <Col xs={24} md={8} className='px-2'>
                    <SelectUC required={!isMilitary} disabled={isMilitary || isReadOnly} label='สถานภาพทางทหาร' name={'militaryStatus'} optionValues={ddlMilitaryStatus} />
                </Col>
            </Row>
            <Row className="py-2">
                <Col xs={24} md={8} className='px-2 expect-salary'>
                    <InputUC
                        disabled={isReadOnly}
                        name={"salary"}
                        label="เงินเดือนที่ต้องการ"
                        maxLength={8}
                        required={true}
                        onBlur={comma}
                        onChange={(e) => handleChangeSalary(e, 'salary')}
                        onFocus={(e) => handleFocus(e, 'salary')}
                    />
                </Col>
            </Row>
        </div>
    )
}

export default Personal